<img class="full-center" *ngIf="viewerOverviewURL" [src]="viewerOverviewURL" />
<audio id="audioplayer" class="full-center" controls style="height:100%;width:100%">
    <source [src]="viewerURL" type="audio/ogg">
    <source [src]="viewerURL" type="audio/mpeg">
    <source [src]="viewerURL" type="audio/wav">
    {{LOCALIZATION.viewerAudioError}}
</audio>
